export default [
  /* Leads */
  {
    path: '/veiculos',
    name: 'Veiculos',
    meta: {
      descricao: 'Veiculos'
    },
    component: () => import('@/pages/veiculos/Veiculos')
  }
]
